export default {"src":"/_next/static/media/bowlen-kegelen.3c917d7f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};